module.exports = __webpack_public_path__ + "img/wzft_5.224b5906.png";